import { render, staticRenderFns } from "./print_cover_pages.vue?vue&type=template&id=8677403a&scoped=true"
import script from "./print_cover_pages.vue?vue&type=script&lang=js"
export * from "./print_cover_pages.vue?vue&type=script&lang=js"
import style0 from "./print_cover_pages.vue?vue&type=style&index=0&id=8677403a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8677403a",
  null
  
)

export default component.exports